export const categories = {
    categories: null,
    merchants: null,
}

export const merchants = {
    merchants: null,
}
